import { render, staticRenderFns } from "./groupPublishing.vue?vue&type=template&id=6b4bdb7e&scoped=true"
import script from "./groupPublishing.vue?vue&type=script&lang=js"
export * from "./groupPublishing.vue?vue&type=script&lang=js"
import style0 from "./groupPublishing.vue?vue&type=style&index=0&id=6b4bdb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4bdb7e",
  null
  
)

export default component.exports